<div class="source-selection-container">
  <div class="source-selection-header">
    <h3 class="source-selection-title">{{ this.res?.get('SourceSelection_Subtitle') }}</h3>
  </div>

  <div class="source-selection-buttons" fxLayout="row" fxLayoutAlign="space-evenly center">
    <abc-button
      (click)="onCameraButtonClick()"
      [stylingMode]="'outlined'"
      [text]="this.res?.get('SourceSelection_Camera')"
      class="source-selection-button"
    >
    </abc-button>

    <abc-button
      (click)="onFilesOrGalleryButtonClick()"
      [stylingMode]="'outlined'"
      [text]="this.res?.get('SourceSelection_Data')"
      class="source-selection-button"
    >
    </abc-button>

    <abc-button
      (click)="this.onCloseDemand.emit()"
      [stylingMode]="'outlined'"
      [text]="this.res?.get('Button_Cancel')"
      class="source-selection-button"
    >
    </abc-button>
  </div>
</div>
